export class Storage {
    constructor(name) {
        if (!['sessionStorage', 'localStorage'].includes(name)) {
            throw new Error(`Unsupported type of storage ${name}`);
        }

        this.name = name;

        try {
            this.storage = window[name];
        } catch (e) {
            this.storage = new MemoryStorage();
        }
    }

    getItem = (key) => {
        let value;

        try {
            value = JSON.parse(this.storage.getItem(key));
        } catch (err) {
            console.warn(`${this.name} getItem is unavailable`);
        }

        return value;
    };

    setItem = (key, value) => {
        try {
            this.storage.setItem(key, JSON.stringify(value));
        } catch (e) {
            console.warn(`${this.name} is full, don't set anything`);
        }
    };

    setItemSimple = (key, value) => {
        this.storage.setItem(key, value);
    };

    hasItem = (key) => {
        return this.storage.getItem(key) !== null;
    };

    removeItem = (key) => {
        this.storage.removeItem(key);
    };

    clear = (pattern) => {
        if (pattern) {
            for (const key in this.storage) {
                if (key.match(pattern)) {
                    this.storage.removeItem(key);
                }
            }
        } else {
            this.storage.clear();
        }
    };

    key = (number) => {
        return this.storage.key(number);
    };

    get length() {
        return this.storage.length;
    }
}

export class MemoryStorage {
    data = {};

    setItem = (id, val) => {
        return this.data[id] = String(val);
    };

    getItem = (id) => {
        return this.data[id];
    };

    removeItem = (id) => {
        return delete this.data[id];
    };

    clear = () => {
        return this.data = {};
    };
}

export const storageService = {
    local: new Storage('localStorage'),
    session: new Storage('sessionStorage')
};
